/**
 * Cleopatra's marks on a fighter (D45), on its name tag so they follow it:
 * pink pixel hearts rising over a charmed one, green venom bubbles over a
 * poisoned one. Built once per tag, shown by a class.
 */
export function statusMarks(label: HTMLElement, charmed: boolean, poisoned: boolean): void {
  if ((charmed || poisoned) && !label.querySelector(".status-marks")) {
    const marks = document.createElement("div");
    marks.className = "status-marks";
    marks.setAttribute("aria-hidden", "true");
    for (let i = 0; i < 3; i++) {
      const heart = document.createElement("i");
      heart.className = "mark-heart";
      heart.style.setProperty("--i", String(i));
      const bubble = document.createElement("b");
      bubble.className = "mark-bubble";
      bubble.style.setProperty("--i", String(i));
      marks.append(heart, bubble);
    }
    label.append(marks);
  }
  if (label.classList.contains("charmed") !== charmed) label.classList.toggle("charmed", charmed);
  if (label.classList.contains("poisoned") !== poisoned) label.classList.toggle("poisoned", poisoned);
}
